"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Breadcrumbs = _interopRequireDefault(require("@mui/material/Breadcrumbs"));
var _react = _interopRequireDefault(require("react"));
var _Link = _interopRequireDefault(require("./Link.js"));
var _BreadcrumbsModule = _interopRequireDefault(require("./Breadcrumbs.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Breadcrumbs component (from HOPSA)
 * Not exported, for compatibility with BasicView.
 *
 * 
 * @package HOPS
 * @subpackage Components
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */class Breadcrumbs extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Breadcrumbs.default, {
      className: _BreadcrumbsModule.default.breadcrumbs,
      separator: ">",
      children: this.props.items.filter(i => !!i.label).map((i, key) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
        color: key === this.props.items.length - 1 ? "textPrimary" : "primary",
        label: i.label,
        uri: i.uri
      }, key))
    });
  }
}
var _default = exports.default = Breadcrumbs;